import { jsx } from 'react/jsx-runtime';
import { Row, Col } from '@teko/ds-desktop';
import { g as getTrackingData } from './tracking-3282e302.js';
import { E as EnhancedImage } from './EnhancedImage-5956213c.js';

const FeaturedBanners = ({ banners, regionName, }) => {
    if (!banners || !banners.length)
        return null;
    const googleImageWidth = Math.ceil(1232 / banners.length);
    return (jsx(Row, Object.assign({ gutter: [16, 16] }, { children: banners.map((banner, index) => (jsx(Col, Object.assign({ span: 12 / banners.length }, { children: jsx(EnhancedImage, Object.assign({ borderRadius: "8px" }, banner, { tracking: getTrackingData({
                    regionName,
                    index,
                    target: banner === null || banner === void 0 ? void 0 : banner.link.href,
                    contentName: banner === null || banner === void 0 ? void 0 : banner.name,
                    isTrackContent: true,
                }), hover: "zoom", googleImageParams: {
                    width: googleImageWidth,
                } }), void 0) }), index))) }), void 0));
};

export { FeaturedBanners as F };
